import { render, staticRenderFns } from "./MultiSectionQuestionModal.vue?vue&type=template&id=5fe9fa3a&scoped=true"
import script from "./MultiSectionQuestionModal.vue?vue&type=script&lang=js"
export * from "./MultiSectionQuestionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe9fa3a",
  null
  
)

export default component.exports